import React, { useEffect, useLayoutEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../Store';
import { domainDetails } from '../Store/Slices/SubAccount/subaccount.selectors';

const useFavicon = () => {
    // const dispatch = useAppDispatch();
    const domainDetailsData:any=useAppSelector(domainDetails)

    const updateFavicon = (iconUrl: string) => {
        let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        if (link) {
          link.href = iconUrl;
        } else {
          link = document.createElement("link");
          link.rel = "icon";
          link.href = iconUrl;
          document.head.appendChild(link);
        }
      };

    useLayoutEffect(() => {
        const faviconUrl = window.location.hostname !== process.env.REACT_APP_DOMAIN_NAME ? domainDetailsData?.image : (window.location.hostname === process.env.REACT_APP_DOMAIN_NAME) ? "/favicon.png" : ""; 
        updateFavicon(faviconUrl);
    }, [domainDetailsData?.image]); 
}

export default useFavicon